// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__25Fk5","box":"WorkspacesBox_box__3f3-D","node":"WorkspacesBox_node__pKF0u"};